export { JsonLdFaq as default } from './JsonLdFaq';